import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteHerausgeberCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteHerausgeberCommandService],
  exports: []
})
export class DeleteHerausgeberCommandServiceModule { }
